var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup90503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #232323;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90503",
    "data-name": "Group 90503",
    transform: "translate(1741 23116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Id_proof_1155065",
    "data-name": "noun_Id proof_1155065",
    transform: "translate(-1750.57 -23138.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92747",
    "data-name": "Path 92747",
    className: "cls-1",
    d: "M30.57,24.037a1.793,1.793,0,0,0-1.818-1.767H11.388A1.793,1.793,0,0,0,9.57,24.037V34.5a1.793,1.793,0,0,0,1.818,1.767H28.752A1.793,1.793,0,0,0,30.57,34.5ZM29.012,34.5a.256.256,0,0,1-.26.252H11.388a.256.256,0,0,1-.26-.252V24.037a.256.256,0,0,1,.26-.252H28.752a.256.256,0,0,1,.26.252Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45603",
    "data-name": "Rectangle 45603",
    className: "cls-1",
    width: 5.237,
    height: 1.602,
    transform: "translate(21.232 26.827)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45604",
    "data-name": "Rectangle 45604",
    className: "cls-1",
    width: 5.504,
    height: 1.602,
    transform: "translate(21.225 30.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92748",
    "data-name": "Path 92748",
    className: "cls-1",
    d: "M24.5,36.5a3.6,3.6,0,1,0,3.577,3.6A3.6,3.6,0,0,0,24.5,36.5Zm0,5.606a2,2,0,1,1,1.975-2A2,2,0,0,1,24.5,42.105Z",
    transform: "translate(-8.283 -10.833)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup90503);
export default __webpack_public_path__ + "static/media/Group 90503.2ddd0e2c7b5c1ebc68a25465948eda91.svg";
export { ForwardRef as ReactComponent };